import React, {useMemo} from "react";

import Button from "../../Interface/Button/Button";
import Box from "../../Interface/Box";
import UnlockButton from "../../Interface/UnlockButton";
import { useWeb3React } from '@web3-react/core';
import StakingModal from "../Modals/StakingModal";
import UnstakingModal from "../Modals/UnstakingModal";
import useResize from "../../../hooks/useResize";
import './style.scss';

function StakingManager() {
    const {account} = useWeb3React();

    const [stakingOpened, setStakingOpened] = React.useState(false);
    const [unstakingOpened, setUnstakingOpened] = React.useState(false);
    const { windowWidth } = useResize();
    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <Box className="manager" justify="space-between" direction={mobileView ? "column" : null}>
            <span className="manager-title">
                Staking Manager
            </span>
            {stakingOpened && <StakingModal isOpen={stakingOpened} setIsOpen={setStakingOpened} />}
            {unstakingOpened && <UnstakingModal isOpen={unstakingOpened} setIsOpen={setUnstakingOpened} />}
            <div className="manager-wrapper">
                {account ? (
                    <React.Fragment>
                        <Button className="manager-button" onClick={() => setUnstakingOpened(true)}>
                            Unstake
                        </Button>
                        <Button className="highlightedButton manager-button" highlight style={mobileView ? null : {marginLeft: 20}} onClick={() => setStakingOpened(true)} >
                            Stake
                        </Button>
                    </React.Fragment>
                ) : (
                    <UnlockButton />
                )}
            </div>
        </Box>
    );
}

export default StakingManager;
